module.exports = __webpack_public_path__ + "img/fire_engine.19a779f7.gif";